import React, { useEffect, useState } from "react";
import { actionCreators } from "../store/RequestResultState";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { Typography, Paper, Grid, Box, CircularProgress, Button } from "@mui/material";
import { useParams, useNavigate } from "react-router-dom";
import { useAppStyles } from "../styles";
import { useTheme } from '@mui/material/styles';
import SellIcon from '@mui/icons-material/Sell';
import { TextSkeleton } from "../form/Skeleton";
import LineChart from "../chart/LineChart";


const RequestInfo = props => {
    const { request, isSkeleton } = props;
    const { classes: appClasses } = useAppStyles();

    const [showClientDetails, setShowClientDetails] = useState(false);

    if (isSkeleton) {
        return (<TextSkeleton sx={{ height: "130px", marginBottom: "25px", width: "100%" }} />);
    }

    return (
        <Grid container item xs={12} className={appClasses.profileWrapper} sx={{ minHeight: "500px" }}>

            <Grid className={appClasses.profileRow} item xs={12}>
                <Typography component="div">REQUEST ID:</Typography>
                <Box className={appClasses.profileValue}>{request.id}</Box>
            </Grid>
            <Grid className={appClasses.profileRow} item xs={12}>
                <Typography component="div">CLIENT ID:</Typography>
                <Box className={appClasses.profileValue}>{request.clientId}</Box>
            </Grid>
            <Grid className={appClasses.profileRow} item xs={12}>
                <Typography component="div">CREDIT AMOUNT:</Typography>
                <Box className={appClasses.profileValue}>{request.requestedAmount}</Box>
            </Grid>
            <Grid className={appClasses.profileRow} item xs={12}>
                <Typography component="div">CREDIT DURATION:</Typography>
                <Box className={appClasses.profileValue}>{request.creditDuration}</Box>
            </Grid>
            <Grid className={appClasses.profileRow} item xs={12}>
                <Typography component="div">CLIENT PROFILE:</Typography>
                <Box className={appClasses.profileDesc}>{request.client.description}</Box>
                <Button variant="outlined" className={appClasses.detailsBtn} onClick={() => setShowClientDetails(!showClientDetails)}>{showClientDetails ? "Hide details" : "Show details"}</Button>
            </Grid>
            {showClientDetails && (
                <>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">PERCENT UNCATEGORIZED PAYMENTS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.sumTotalPaymentsMccCatMissingMccToTotalPerc.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">PERCENT POS PAYMENTS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.sumTotalPaymentsSubtotalToTotalPerc.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">SUM DEBIT CARD PAYMENTS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.sumDcTotalPaymentsTotalL3d.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">SUM NON-NETWORK ATM WITHDRAWALS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.sumDcTotalPaymentsMccCatCat.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">PERCENT NETWORK ATM WITHDRAWALS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.sumDcTotalPaymentsAtmWithdrawalToTotalPerc.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">PERCENT FEES / INTEREST PAYMENTS TO TOTAL PAYMENTS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.sumTotalPaymentsFeeOrInterestToTotalPerc.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">COUNT NETWORK ATM WITHDRAWALS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.countDcTotalPaymentsAtmWithdrawal.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">PERCENT NETWORK ATM WITHDRAWALS ON WORK DAYS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.sumWorkingDaysTotalPaymentsAtmWithdrawalToTotalPercL3d.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">COUNT NON-NETWORK ATM WITHDRAWALS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.countDcTotalPaymentsMccCatCat.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">SUM PAYMENTS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.sumDcTotalPaymentsTotalL1d.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">PERCENT CREDIT CARD POS PAYMENTS COUNT TO TOTAL COUNT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.countCcTotalPaymentsSubtotalToTotalPercL3d.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">RATIO CREDIT CARD PAYMENTS COUNT TO DEBIT CARD PAYMENTS COUNT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.countCcTotalRatioPos.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">SUM NETWORK ATM DEBIT CARD WITHDRAWALS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.sumDcTotalPaymentsAtmWithdrawal.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">PERCENT POS PAYMENTS COUNT TO TOTAL COUNT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.countTotalPaymentsSubtotalToTotalPerc.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">PERCENT NETWORK ATM WITHDRAWALS ON WORK DAYS {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.sumWorkingDaysTotalPaymentsAtmWithdrawalToTotalPercL1d.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">MEAN CREDIT CARD PAYMENT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.meanCcTotalPaymentsTotal.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">PERCENT LEISURE AND ENTERTAINMENT PAYMENTS COUNT TO TOTAL COUNT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 3 MONTHS)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.countTotalPaymentsMccCatCatToTotalPerc.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">PERCENT CREDIT CARD POS PAYMENTS COUNT TO TOTAL COUNT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.countCcTotalPaymentsSubtotalToTotalPercL1d.toFixed(2)}</Box>
                    </Grid>
                    <Grid className={appClasses.profileRow} item xs={12}>
                        <Typography component="div">PERCENT FEES / INTEREST PAYMENTS COUNT TO TOTAL COUNT {<Box className={appClasses.profileValuePeriod} component={"span"}>(LAST 1 MONTH)</Box>}:</Typography>
                        <Box className={appClasses.profileValue}>{request.client.countTotalPaymentsFeeOrInterestToTotalPerc.toFixed(2)}</Box>
                    </Grid>
                </>
            )}
        </Grid>
    );
}

const Interest = props => {
    const { value } = props;
    const theme = useTheme();

    return (
        <Box sx={{ display: "flex", flexGrow: 1, alignItems: "center", border: "1px solid", borderColor: theme.palette.success.main, borderRadius: "8px", padding: "8px" }}>
            <Box>
                <Box>
                    <SellIcon fontSize="large" sx={{ fontSize: "45px", color: theme.palette.success.main }} />
                </Box>
            </Box>
            <Box sx={{ color: theme.palette.success.main, marginLeft: "10px" }}>
                <Typography sx={{ display: "block" }}>INTEREST RATE {value} %</Typography>
            </Box>
        </Box>);
};

const RequestResultPage = props => {
    const { getData, resetState, loading, result } = props;
    const { classes: appClasses } = useAppStyles();
    const { requestId } = useParams();
    const navigate = useNavigate();

    useEffect(() => {
        getData(requestId, navigate);

        return () => {
            resetState();
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    if (loading) {
        return (
            <Grid container className={appClasses.formWrapper} component={Paper}>
                <Grid item className={appClasses.loadingIndicator} xs={12}>
                    <CircularProgress />
                </Grid>
            </Grid>
        );
    }

    return (
        <Grid container className={appClasses.formWrapper} component={Paper}>
            {result &&
                <>
                    <Grid container item spacing={2} className={appClasses.resultWrapper} xs={12}>
                        <Grid item xs={12} sm={6}>
                            <RequestInfo request={result} />
                        </Grid>
                        {
                            result && (
                                <Grid container item xs={12} sm={6}>
                                    <Grid item xs={12} sx={{ display: "flex", alignItems: "center" }}>
                                        <Interest value={result.interest.toFixed(2)} />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Box className={appClasses.elasticityChart} sx={{ marginTop: "45px" }}>
                                            <Typography sx={{ marginBottom: "30px", paddingLeft: "16px" }}>ELASTICITY CURVE:</Typography>
                                            <Box sx={{ width: "100%", minHeight: "300px" }}>
                                                <LineChart elasticityCurve={result.elasticityCurve} />
                                            </Box>
                                        </Box>
                                    </Grid>
                                </Grid>

                            )
                        }
                    </Grid>
                </>
            }

        </Grid>
    );
}

export default connect(
    (state) => state.requestResult,
    (dispatch) => bindActionCreators(actionCreators, dispatch)
)(RequestResultPage)
